import LAlert from "components/LAlert";
import { hideLoading } from "components/LLoading";
import { LTMTransactionStatus } from "core/enums/transaction";
import { EPaymentMethod } from "pages/Context/LandinPageContext";
import { GetTransactionsById } from "pages/Pricing/service/payment.service";
import { Dispatch, SetStateAction } from "react";

export const monitorTransaction = async (
  transactionId: string,
  onHideLoading: boolean,
  paymentMethod: EPaymentMethod,
  setCurrentStep: Dispatch<SetStateAction<number>>,
  onManual?: () => void,
) => {  let isPending = true;
  let time = 1000;

  onHideLoading && hideLoading();

  while (isPending) {
    await new Promise((resolve) => setTimeout(resolve, time));

    try {
      const transaction = await GetTransactionsById(transactionId);

      if (transaction.paymentStatus !== LTMTransactionStatus.PENDING) {
        isPending = false;

        if (transaction.paymentStatus === LTMTransactionStatus.APPROVED) {
          setCurrentStep(4);
        } else if (transaction.paymentStatus === LTMTransactionStatus.GATEWAY_FAILED) {
          // Gateway falhou → fluxo manual. Avança pro sucesso marcando como manual.
          if (onManual) onManual();
          else setCurrentStep(4);
        } else {
          LAlert({
            description: "Erro ao processar pagamento. Tente novamente ou entre em contato com o suporte!",
            duration: 7000
          });
        }
      }

      if(paymentMethod === EPaymentMethod.CREDIT_CARD && time === 180000) {
        isPending = false;
        LAlert({
          description: "Erro ao processar pagamento. Tente novamente ou entre em contato com o suporte!",
          duration: 7000
        });
      } 

      if(paymentMethod === EPaymentMethod.CREDIT_CARD) time = time * 2;
    } catch (error) {
      LAlert({description: `${error}`});
      isPending = false;
    } 
  }
};